import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

class Heading3 extends React.Component {
  render() {
    let h3Class = classNames(
      "f4",
      "lh-title",
      "mt0",
      "sans-serif",
      { db: !this.props.inline, dib: this.props.inline },
      { mb2: !this.props.inline, mb0: this.props.inline },
      this.props.color,
      this.props.weight,
      this.props.fontStyle
    );
    return <h3 className={h3Class}>{this.props.children}</h3>;
  }
}

Heading3.defaultProps = {
  color: "black",
  weight: "fw5",
  fontStyle: "fs-normal",
  inline: false
};

Heading3.propTypes = {
  color: PropTypes.string,
  weight: PropTypes.string,
  fontStyle: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf([PropTypes.node])
  ]),
  inline: PropTypes.bool
};

export default Heading3;
